import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-tel-input/dist/vue-tel-input.css'
import locale from 'element-ui/lib/locale/lang/en'
import '@/styles/index.scss' // global css
import '@/styles/fontastic.css' // fontastic css
import '@/styles/style.css'
import '@/styles/responsive.css'
// import '@/styles/style.css'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import './permission' // permission control

import jQuery from 'jquery'
window.jQuery = jQuery
window.$ = jQuery
import 'bootstrap'

/////////////////////////////
// ELEMENT UI
/////////////////////////////
Vue.use(Element, {
  locale,
  size: Cookies.get('size') || 'large' // set element-ui default size
})

/////////////////////////////
// FILTERS
/////////////////////////////
import * as filters from './filters' // global filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import VueTelInput from 'vue-tel-input'

var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

import underscore from 'underscore'
Vue.use(underscore)
import {_} from 'underscore';

/*
Vue Google Map
*/
import 'vue-googlemaps/dist/vue-googlemaps.css'
import VueGoogleMaps from 'vue-googlemaps'
Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    apiKey: 'AIzaSyDQJx-KDJUimSyyVUwOBRrrzTG22-rvz18',
    // Enable more Google Maps libraries here
    libraries: ['places'],
    // Use new renderer
    useBetaRenderer: false,
  },
})
// import VueGoogleMap from '@codekraft-studio/vue-google-map'
// Vue.use(VueGoogleMap, {
//   load: {
//     apiKey: 'AIzaSyDQJx-KDJUimSyyVUwOBRrrzTG22-rvz18',
//     libraries: ['places']
//   }
// })
// // /Applications/MAMP/htdocs/OpenCabana/opencabana-v2/node_modules/vue2-google-maps/dist/main.js
//import * as VueGoogleMaps from 'vue2-google-maps'
// // import * as VueGoogleMaps from '~/node_modules/vue2-google-maps'
// import * as VueGoogleMaps from 'vue2-google-maps/dist/main.js'
// // import * as VueGoogleMaps from 'vue2-google-maps/dist/main.js'
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyDQJx-KDJUimSyyVUwOBRrrzTG22-rvz18',
//     libraries: 'places' // necessary for places input
//   }
// })
// import 'vue-googlemaps/dist/vue-googlemaps.css'
// import VueGoogleMaps from 'vue-googlemaps'
//
// Vue.use(VueGoogleMaps, {
//   load: {
//     // Google API key
//     apiKey: 'your-google-api-key',
//     // Enable more Google Maps libraries here
//     libraries: ['places'],
//     // Use new renderer
//     useBetaRenderer: false,
//   },
// })

Vue.mixin({
  /* ************************ */
  /* GLOBALLY DECLARED PARAMS */
  /* ************************ */
  data() {
    return {
      // paginationLimit: 20,
      phone_format: '',
      preferred_countries: [],
      only_countries: ['us', 'in'],
      default_country: 'US',
      disabled_fetching_country: true
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user.user_id ? true : false
    },
    userId() {
      return this.$store.state.user.user_id
    },
    userName() {
      return this.$store.state.user.name
    }
  },
  methods: {
    getMilliseconds() {
      let d = new Date()
      return d.getMilliseconds()
    },
    diffHours(date_from) {
      return Math.floor(Math.abs(+new Date() - +new Date(date_from)) / 36e5)
    },
    calculateReservationTax(taxableAmount, taxPercent) {
      return this.priceOnly((taxableAmount * taxPercent) / 100)
    },
    calculateReservationServiceFee(totalAmount, serviceFeePercent) {
      return this.priceOnly((totalAmount * serviceFeePercent) / 100)
    },
    calculateReservationCommissionAmount(totalSeatPrice, reservationCommission, reservationCommissionType) {
      let amount = 0
      // Flat
      if (reservationCommissionType === 'flat') {
        amount = this.priceOnly(reservationCommission)
      // Percent
      } else {
        amount = this.priceOnly((totalSeatPrice * reservationCommission) / 100)
      }
      return amount
    },
    /**
     * @param {string} number
     * the phone number inputted by user, will be formatted along with country code
     * // Ex: inputted: (AU) 0432 432 432
     * // number = '+61432421546'
     *
     * @param {Boolean} isValid
     * @param {string} country
     */
    onInputPhone({
      number,
      isValid,
      country
    }) {
      if (isValid) {
        this.postForm.phone_number = number.replace(country.dialCode, '').replace('+', '')
        this.postForm.phone_isd = country.dialCode
      }
    },
    onValidatePhone({
      number,
      isValid,
      country
    }) {
      if (isValid) {
        this.validPhone = true
        // find the guest and populate guest information
      } else {
        this.validPhone = false
      }
    },
    formatPhoneNumber({
      number,
      isValid,
      country
    }) {
      this.phone_number = country.dialCode + number
    },
    validatePhone() {
      if (this.rules.phone_number[0].required && this.postForm.phone_number !== '' && this.validPhone) {
        return true
      } else if (!this.rules.phone_number[0].required && this.postForm.phone_number === '') {
        return true
      } else if (!this.rules.phone_number[0].required && this.postForm.phone_number !== '' && this.validPhone) {
        return true
      } else {
        return false
      }
    },
    priceOnly (str) {
      if (str) {
        str = str.toString()
        return parseFloat(str.replace(/[^\d.]/g, ''))
      }
      return 0
    },
    formatPrice (price, currency) {
      return (currency ? currency : '$') + this.priceOnly(price).toFixed(2)
    },
    convertDateFormat(str, format = 1) {
      let date = new Date(str);
      let mnth = ('0' + (date.getMonth() + 1)).slice(-2);
      let day = ('0' + date.getDate()).slice(-2);
      if (format == 1) {
        str = [ mnth, day, date.getFullYear() ].join('/')
      }
      else if (format == 2) {
        str = [ date.getFullYear(), mnth, day ].join('-')
      }
      return str;
    },
    validationScrollTo(id) {
      this.$scrollTo(id, 500)
    },
    /**
       * Appends the the error to the b-modal form
       * @param {Object} errors Data return Laravel form validation error
       */
    validationErrors(err) {
      this.validationScrollTo('#postForm')
      // laravel Validator generated errors appends on template
      _.each(this.p__errors, (element, index) => {
        this.p__errors[index] = ''
      })
      let messages = []
      _.each((JSON.parse(err)), (element, index) => {
        if (!this.p__errors.hasOwnProperty(index)) {
          messages.push(element[0])
        } else {
          this.p__errors[index] = element[0]
        }
      })
      if (messages.length > 0) {
        // this.$message.error(messages.filter(this.onlyUnique).join(', '), 50000)
        this.flashError(messages.filter(this.onlyUnique).join(', '))
      }
    },
    /**
       * Remove the form errors
       * @param {Object} errors Data return Laravel form validation error
       */
    resetFormErrors() {
      const _t = this
      _.each(_t.p__errors, function(element, index) {
        _t.p__errors[index] = ''
      })
    },

    onlyUnique(value, index, self) {
      return self.indexOf(value) === index
    },

    /*
     * Will display success message
     */
    flashSuccess: function(message, title) {
      this.$notify.success({
        title: title || 'Success',
        message: message || ''
      })
    },
    /*
     * Will display error message
     */
    flashError: function(message, title) {
      this.$notify.error({
        title: title || 'Error',
        message: message || ''
      })
    },
    /*
     * Will display info message
     */
    flashInfo: function(message, title) {
      this.$notify.info({
        title: title || 'Info',
        message: message || ''
      })
    }
  }
})

Vue.config.productionTip = false

router.beforeEach(({meta, path}, from, next) => {
  if (path === '/home') {
    document.body.classList.add("home")
    document.body.classList.remove("page")
  } else {
    document.body.classList.remove("home")
    document.body.classList.add("page")
  }
  next()
});

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js